import {observer} from 'mobx-react-lite'
import React from 'react'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {trackPageClick} from '@components/main-menu/handlers/tracking'
import {Page} from '@extensions/page'
import {goto} from '../handlers/main-handlers'
import {useMainMenuStore} from '../main-menu-store'
import {MenuIconButtonWithTooltip} from './menu-icon-button-with-tooltip'

interface Props {
  icon: TablerIcons
  page: Page
  hint?: string
  notification?: boolean
}

export const MenuIconButtonPage = observer((props: Props) => {
  const {icon, page, hint} = props
  const {notification} = props
  const [state] = useMainMenuStore()
  const {currentPage} = state

  const gotoClick = () => {
    goto(page)
    trackPageClick(page)
  }
  const active = currentPage === page

  return (
    <MenuIconButtonWithTooltip
      icon={icon}
      hint={hint}
      notification={notification}
      onClick={gotoClick}
      active={active}
      className="mb-8"
    />
  )
})
